import Joi from '@hapi/joi'

export const EOSSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group cannot have invalid characters`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Operatin Entity cannot have invalid characters`,
        "any.required": `Operatin Entity required`
    }),
    collectionPointID: Joi.number().required().label("Collectionpoint").messages({
        "any.invalid": `Collectionpoint cannot have invalid characters`,
        "any.required": `Collectionpoint required`
    }),
    aspNetUserId: Joi.number().required().label("User").messages({
        "any.invalid": `User cannot have invalid characters`,
        "any.required": `User required`
    }),
}